/**
* Components are lazy-loaded - See "Grouping Components in the Same Chunk"
* http://router.vuejs.org/en/advanced/lazy-loading.html
*/
/* eslint-disable global-require */

const scenario = r => require.ensure([], () => r(require('./components/index')), 'scenario');

const manageScenario = {
    index:       r => require.ensure([], () => r(require('./components/manage/index')),         'manage-scenario'),
    //create:      r => require.ensure([], () => r(require('./components/manage/create')),           'manage-scenario'),
    description: r => require.ensure([], () => r(require('./components/manage/edit/description')), 'manage-scenario'),
    email:       r => require.ensure([], () => r(require('./components/manage/edit/email')),       'manage-scenario'),
    whatsapp:       r => require.ensure([], () => r(require('./components/manage/edit/email')),       'manage-scenario'),
    team:       r => require.ensure([], () => r(require('./components/manage/edit/email')),       'manage-scenario'),
    sms:       r => require.ensure([], () => r(require('./components/manage/edit/email')),       'manage-scenario'),
    landing:     r => require.ensure([], () => r(require('./components/manage/edit/landing')),     'manage-scenario'),
    education:    r => require.ensure([], () => r(require('./components/manage/edit/education')),    'manage-scenario'),
    review:    r => require.ensure([], () => r(require('./components/manage/edit/review')),    'manage-scenario')
};

export default [
    {
        name: 'scenario',
        path: '/scenario',
        component: scenario,
    },
    {
        name: 'scenario.index',
        path: '/scenario/create',
        component: manageScenario.index,
        redirect: { name: 'scenario.create' },
        children: [
            {
                name: 'scenario.description',
                path: '/scenario/description',
                component: manageScenario.description,
            },
            {
                name: 'scenario.edit.description',
                path: '/scenario/description/:id', 
                component: manageScenario.description,
            },
            {
                name: 'scenario.edit.email',
                path: '/scenario/email/:id',
                component: manageScenario.email,
            },
            {
                name: 'scenario.edit.sms',
                path: '/scenario/sms/:id',
                component: manageScenario.sms,
            },
            {
                name: 'scenario.edit.team',
                path: '/scenario/team/:id',
                component: manageScenario.team,
            },
            {
                name: 'scenario.edit.whatsapp',
                path: '/scenario/whatsapp/:id',
                component: manageScenario.whatsapp,
            },
            {
                name: 'scenario.edit.landing',
                path: '/scenario/landing/:id',
                component: manageScenario.landing,
            },
            {
                name: 'scenario.edit.education',
                path: '/scenario/education/:id',
                component: manageScenario.education,
            },
            {
                name: 'scenario.edit.review',
                path: '/scenario/review/:id',
                component: manageScenario.review,
            }
        ]
    }
]







// WEBPACK FOOTER //
// ./src/app/scenario/routes.js